// extracted by mini-css-extract-plugin
export default {"wrap":"AI-z","articleImagesWrap":"BI-z","articleImage":"CI-z","singleImage":"DI-z"};